import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/es/downloads/checklists")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
